import {
  $post, $get, $JsonPost, vte,
} from '@/utils/axios-request';


class WordDetail {
  // 词汇详情
  public async getWordDetail(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/getWordDetail`, postData);
  }

  // 查询文章详情
  public async getArticleDetail(postData: any): Promise<any> {
    return await $get(`${vte}/article/api/getArticleDetail`, postData);
  }

  // 添加助标
  public async addStudentMnemonic(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/addUserMnemonic`, postData);
  }

  // 口语测评次数
  public async voiceCountNum(postData: any): Promise<any> {
    return await $get(`${vte}/word/api/v1/incrementOralNum`, postData);
  }
}
export default new WordDetail();
